import * as ationTypes from './mutation-types'
import * as mutationTypes from './action-types'

export default {    
  ...ationTypes,
  ...mutationTypes
}